import axios from 'axios'

import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { errorResponseInterceptor } from '../../../interceptors/http-interceptor/errorResponse'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'
import { basicXRequestInterceptor } from '../../../interceptors/http-interceptor/basicX'

export const configureBasicXAPI = (url: string) => {
  const instance = axios.create({ baseURL: url })

  instance.interceptors.request.use(
    basicXRequestInterceptor,
    errorRequestInterceptor
  )
  instance.interceptors.response.use(
    responseInterceptor,
    errorResponseInterceptor
  )

  return instance
}
